import { Component, OnInit } from '@angular/core';
import { IMidtermExamPayment } from '../../models/MidtermExamPayment';

import { AppService } from '../../services/app.service';
import { MidtermExamPaymentService } from '../../services/midterm-exam-payment.service';
import { ITableColumn } from '../../shared/table/table.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MidtermExamPaymentDetailsComponent } from './details.component';

@Component({
    selector: 'app-midterm-exam-payment-list',
    templateUrl: './list.component.html'
})
export class MidtermExamPaymentListComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: MidtermExamPaymentService,
        private modal: NgbModal
    ) { }

    items: IMidtermExamPayment[] = [];
    canAdd: boolean;

    readonly columns: ITableColumn[] = [
        { property: 'CourseName', label: 'midtermExamPayment_lblStudent', sorts: true, cssClass: 'hidden-md-up' },
        { property: 'CourseName', label: 'midtermExamPayment_lblCourse', sorts: true, cssClass: 'hidden-sm-down' },
        { property: 'StudentFullName', label: 'midtermExamPayment_lblStudent', sorts: true, cssClass: 'hidden-sm-down' },
        { property: 'Created', label: 'midtermExamPayment_lblCreated', sorts: true, type: 'date', cssClass: 'hidden-sm-down' },
        { property: 'Status', label: 'midtermExamPayment_lblStatus', sorts: true, cssClass: 'hidden-sm-down' },
        { width: '1px' }
    ];

    readonly filters: {
        text?: string,
        course: { options: { id: string, name: string }[], value: string[] },
        semester: { options: string[], value: string[] }
    } = {
            course: { options: [], value: [] },
            semester: { options: [], value: [] }
        };

    private allItems: IMidtermExamPayment[] = [];

    ngOnInit() {
        this.canAdd = this.app.currentUser.hasRight('MIDTERM_EXAM_PAYMENT.EDIT');

        this.fetch();
    }

    filter() {
        const text = this.filters.text?.toLowerCase();
        const course = this.filters.course.value;
        const semester = this.filters.semester.value;

        if (text || course || semester) {
            this.items = this.allItems.filter(t => {
                if (course.length && !course.includes(t.CourseId)) return false;
                if (semester.length && !semester.includes(t.Semester)) return false;
                if (text) {
                    if (t.CourseCode?.toLowerCase().includes(text)) return true;
                    if (t.CourseName?.toLowerCase().includes(text)) return true;
                    if (t.TeacherFullName?.toLowerCase().includes(text)) return true;
                    if (t.StudentFullName?.toLowerCase().includes(text)) return true;
                    if (t.StudentUpn?.toLowerCase().includes(text)) return true;
                    return false;
                }
                return true;
            });
        } else {
            this.items = this.allItems;
        }
    }

    open(item: IMidtermExamPayment) {
        const modalRef = this.modal.open(MidtermExamPaymentDetailsComponent, { size: 'md' });
        modalRef.componentInstance.id = item.Id;

        modalRef.result.then(data => {
            Object.assign(item, data);  
        }, () => { });
    }

    private fetch(upn?: string) {
        this.app.addLoading(this.service.get(upn)).subscribe(data => {
            this.allItems = data;

            const courses: { id: string, name: string }[] = [];
            const semesters: string[] = [];

            data.forEach(t => {
                if (!courses.some(c => c.id == t.CourseId)) {
                    courses.push({ id: t.CourseId, name: `${t.CourseCode} - ${t.CourseName}` });
                }
                if (!semesters.includes(t.Semester)) {
                    semesters.push(t.Semester);
                }
            });

            this.filters.course.options = courses;
            this.filters.semester.options = semesters;

            this.filter();
        });
    }
}
